import React, { useMemo } from 'react';

import { cn } from 'components/lib/utils';

interface CodeBlockProps {
  content: unknown;
  className?: string;
}

export const CodeBlock: React.FC<CodeBlockProps> = ({ content, className }) => {
  const formattedContent = useMemo(() => {
    if (typeof content === 'string') {
      return content;
    }
    return JSON.stringify(content, null, 2);
  }, [content]);

  return (
    <div
      className={cn(
        'rounded-lg bg-zinc-700 p-4 font-mono text-p-xs text-white overflow-auto h-[200px]',
        className
      )}
    >
      <pre className="whitespace-pre-wrap break-words">{formattedContent}</pre>
    </div>
  );
};
